import { parseEntityItemId } from '@wix/a11y-rules';
import { bulkUpdateItem } from '@wix/ambassador-restaurants-menus-v1-item/http';
import { chunk as getChunks } from 'lodash';
import { fetchRestaurantsMenuItems } from '../new-infra-fetchers/fetch-restaurants-menu-items';
const BULK_LIMIT = 100;
const getItemIdForItem = item => {
  const {
    entities
  } = parseEntityItemId(item.id, 1);
  return entities[0];
};
export const updateRestaurantsMenuItemsAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const itemIds = [...new Set(altTextData.map(getItemIdForItem).filter(id => id !== undefined))];
  try {
    const items = await fetchRestaurantsMenuItems(httpClient, errorHandler, itemIds);
    const itemsMap = new Map(items.map(item => [item.id, item]));
    const maskedItems = buildMaskedItems(altTextData, itemsMap);
    const succeededItemIds = new Set();
    const chunks = getChunks(maskedItems, BULK_LIMIT);
    for (const chunk of chunks) {
      try {
        const response = await withErrorHandler(async () => httpClient.request(bulkUpdateItem({
          items: chunk
        })), {
          errorCodesMap: {}
        });
        (response.data.results ?? []).forEach(result => {
          var _result$itemMetadata;
          if ((_result$itemMetadata = result.itemMetadata) != null && _result$itemMetadata.success && result.itemMetadata.id) {
            succeededItemIds.add(result.itemMetadata.id);
          }
        });
      } catch (_error) {}
    }
    const allFailedElements = altTextData.filter(item => {
      const itemId = getItemIdForItem(item);
      return !itemId || !succeededItemIds.has(itemId);
    });
    const overallSuccess = allFailedElements.length === 0;
    return {
      errorMessage: overallSuccess ? undefined : `Failed to update alt text for ${allFailedElements.length} item(s)`,
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
const buildMaskedItems = (altTextData, itemsMap) => {
  const maskedItems = [];
  altTextData.forEach(data => {
    const itemId = getItemIdForItem(data);
    const existingItem = itemId ? itemsMap.get(itemId) : undefined;
    if (!(existingItem != null && existingItem.image)) {
      return;
    }
    const passesAsDecorative = !!data.isDecorative && !data.isLinked;
    maskedItems.push({
      item: {
        ...existingItem,
        image: {
          ...existingItem.image,
          altText: passesAsDecorative ? '' : data.alt
        }
      },
      mask: ['image']
    });
  });
  return maskedItems;
};
//# sourceMappingURL=update-restaurants-menu-items-alt-text.js.map